import React, { useEffect } from 'react';
import { Button, LinkButton } from '../../components/common';
import styled from 'styled-components/macro';
import { FlexColumn, FlexRow } from '../../components/basic/Flex';
import Pictogram from '../../components/common/Pictogram';
import { ThemeColor, themeColors } from '../../theme/theme';
import { DeviceSize } from '../../components/basic/DeviceSize';
import { EventInvitePreview } from '../forms';
import { useMessageGetter } from 'react-message-context';
import { Divider } from '../../components/common/Divider';
import { RouteComponentProps, useLocation, useParams } from 'react-router';
import { useKennoTenant } from '../../context/kennoTenantContext';
import { loadPublicEvents } from '../../context/kennoTenantActions';
import PageContainer from '../PageContainer';
import PaddedContent from '../../components/housing/PaddedContent';
import { Slugs } from '../../constants/knownSlugs';
import { getMenuItemPathBySlug } from '../../utils/wordpress';
import { useAppState } from '../../context/appContext';
import { EVENT_PAGE_QUERY_PARAM, getBackgroundForEventType, getPictogramForEventType } from './event-utils';

const Column = styled(FlexColumn)`
  width: 256px;

  @media print {
    display: none;
  }
`;

const LeftColumn = styled(Column)`
  @media ${DeviceSize.desktopS} {
    display: none;
  }
  @media ${DeviceSize.mobileL} {
    display: none;
  }
`;

const RightColumn = styled(Column)`
  @media ${DeviceSize.desktopS} {
    display: none;
  }
`;

const PictogramCircle = styled.div<{ background: ThemeColor }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 56px;
  background: ${(props) => themeColors[props.background]};
  border-radius: 1000px;
  border: 2px solid ${themeColors.darkSnow};

  @media ${DeviceSize.desktopM} {
    padding: 28px;
  }
`;

const ButtonRow = styled(FlexRow)`
  @media print {
    display: none;
  }
`;

const EventPage = ({ history }: RouteComponentProps) => {
  const t = useMessageGetter('common');
  const { menu } = useAppState();
  const { id: eventId } = useParams<{ id?: string }>();
  const [{ publicEvents }, dispatch] = useKennoTenant();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const queryParamPage = query.get(EVENT_PAGE_QUERY_PARAM);

  useEffect(() => {
    loadPublicEvents(dispatch);
  }, [dispatch]);

  const event = publicEvents.data?.find((event) => event.id === eventId);

  if (!event) return <></>;

  return (
    <PageContainer history={history}>
      <PaddedContent>
        <FlexRow gap="48px" justifyContent="space-between">
          <LeftColumn>
            <PictogramCircle background={getBackgroundForEventType(event.formData.eventType)}>
              <Pictogram width={144} height={144} name={getPictogramForEventType(event.formData.eventType)} />
            </PictogramCircle>
          </LeftColumn>
          <FlexColumn gap="16px">
            <FlexColumn>
              <EventInvitePreview formData={event.formData} />
            </FlexColumn>
            <Divider />
            <ButtonRow gap="16px">
              <LinkButton
                to={`${getMenuItemPathBySlug(menu.items, Slugs.EVENTS)}?${EVENT_PAGE_QUERY_PARAM}=${queryParamPage}`}
                icon="arrowBackward"
                primary
              >
                {t('back')}
              </LinkButton>
              <Button onClick={window.print} icon="print">
                {t('print')}
              </Button>
            </ButtonRow>
          </FlexColumn>
          <RightColumn />
        </FlexRow>
      </PaddedContent>
    </PageContainer>
  );
};

export default EventPage;
